exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-text {\n  padding: 25px 45px 15px 45px;\n  text-align: center;\n  color: #9e9e9e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module id = ../../../../../src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module chunks = main